/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction,
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteDomainRequest } from '../models';
// @ts-ignore
import { GetIsCloudflareProxyEnableResponse } from '../models';
// @ts-ignore
import { UpdateDomainRequest } from '../models';
/**
 * DomainApi - axios parameter creator
 * @export
 */
export const DomainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {DeleteDomainRequest} deleteDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerDeleteDomain: async (
            deleteDomainRequest: DeleteDomainRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'deleteDomainRequest' is not null or undefined
            assertParamExists('domainControllerDeleteDomain', 'deleteDomainRequest', deleteDomainRequest);
            const localVarPath = `/api/domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                deleteDomainRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} siteName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetIsProxyByCloudFlareEnable: async (
            siteName: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('domainControllerGetIsProxyByCloudFlareEnable', 'siteName', siteName);
            const localVarPath = `/api/domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            if (siteName !== undefined) {
                localVarQueryParameter['site_name'] = siteName;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {UpdateDomainRequest} updateDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerUpdateDomain: async (
            updateDomainRequest: UpdateDomainRequest,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'updateDomainRequest' is not null or undefined
            assertParamExists('domainControllerUpdateDomain', 'updateDomainRequest', updateDomainRequest);
            const localVarPath = `/api/domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(
                updateDomainRequest,
                localVarRequestOptions,
                configuration
            );

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * DomainApi - functional programming interface
 * @export
 */
export const DomainApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = DomainApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {DeleteDomainRequest} deleteDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerDeleteDomain(
            deleteDomainRequest: DeleteDomainRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerDeleteDomain(
                deleteDomainRequest,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} siteName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerGetIsProxyByCloudFlareEnable(
            siteName: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIsCloudflareProxyEnableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerGetIsProxyByCloudFlareEnable(
                siteName,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {UpdateDomainRequest} updateDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domainControllerUpdateDomain(
            updateDomainRequest: UpdateDomainRequest,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domainControllerUpdateDomain(
                updateDomainRequest,
                options
            );
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};

/**
 * DomainApi - factory interface
 * @export
 */
export const DomainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DomainApiFp(configuration);
    return {
        /**
         *
         * @param {DeleteDomainRequest} deleteDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerDeleteDomain(deleteDomainRequest: DeleteDomainRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp
                .domainControllerDeleteDomain(deleteDomainRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} siteName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerGetIsProxyByCloudFlareEnable(
            siteName: string,
            options?: any
        ): AxiosPromise<GetIsCloudflareProxyEnableResponse> {
            return localVarFp
                .domainControllerGetIsProxyByCloudFlareEnable(siteName, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateDomainRequest} updateDomainRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domainControllerUpdateDomain(updateDomainRequest: UpdateDomainRequest, options?: any): AxiosPromise<boolean> {
            return localVarFp
                .domainControllerUpdateDomain(updateDomainRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * DomainApi - object-oriented interface
 * @export
 * @class DomainApi
 * @extends {BaseAPI}
 */
export class DomainApi extends BaseAPI {
    /**
     *
     * @param {DeleteDomainRequest} deleteDomainRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    public domainControllerDeleteDomain(deleteDomainRequest: DeleteDomainRequest, options?: any) {
        return DomainApiFp(this.configuration)
            .domainControllerDeleteDomain(deleteDomainRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {string} siteName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    public domainControllerGetIsProxyByCloudFlareEnable(siteName: string, options?: any) {
        return DomainApiFp(this.configuration)
            .domainControllerGetIsProxyByCloudFlareEnable(siteName, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {UpdateDomainRequest} updateDomainRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainApi
     */
    public domainControllerUpdateDomain(updateDomainRequest: UpdateDomainRequest, options?: any) {
        return DomainApiFp(this.configuration)
            .domainControllerUpdateDomain(updateDomainRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
